import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["attachedBy", "attachedStatus"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { CustomAttribute, FolderItem } from '../models';
import { parsePagination, deprecatedWarning } from '../utils/commons';
import { CANCEL_KEYS, DOCS_PRODUCTS } from '../utils/consts';

/**
 * `Service` The custom attribute service
 */
var CustomAttributes = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function CustomAttributes(sdk) {
    var _this;
    _classCallCheck(this, CustomAttributes);
    _this = _callSuper(this, CustomAttributes, [sdk]);
    _this.folderAttributesCancelToken = new Map();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(CustomAttributes, _Base);
  return _createClass(CustomAttributes, [{
    key: "getProjectAttributes",
    value: (
    /**
     * get custom attributes of the project, support search, support sort by name/id, support pagination
     * https://platform.stoplight.autodesk.com/docs/docs-cp/ea6ed85d86126-search-visible-custom-attribute-definitions
     *
     * @param projectId -  the project id.
     * @param payload - with the shape of `offset`, `limit`, `sort`, `q`
     * @param config - Configurable object to overwrite request parameters.
     */
    function () {
      var _getProjectAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, payload, config) {
        var _this2 = this;
        var conf, query, response, _response$data, _response$data$result, results, pagination;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.projectAttributesCancelToken;
                },
                setter: function setter(token) {
                  return _this2.projectAttributesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.projectAttributesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(payload, {
                addQueryPrefix: true
              });
              _context.next = 4;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/custom-attribute-definitions").concat(query), conf);
            case 4:
              response = _context.sent;
              _response$data = response.data, _response$data$result = _response$data.results, results = _response$data$result === void 0 ? [] : _response$data$result, pagination = _response$data.pagination;
              return _context.abrupt("return", {
                attributes: results.map(CustomAttribute.parseV3),
                pagination: parsePagination(pagination)
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProjectAttributes(_x, _x2, _x3) {
        return _getProjectAttributes.apply(this, arguments);
      }
      return getProjectAttributes;
    }()
    /**
     * get all custom attributes of the project
     *
     * @param projectId -  the project id.
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getAllProjectAttributes",
    value: (function () {
      var _getAllProjectAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, config) {
        var _this3 = this;
        var conf, projectAttributes, payload, hasNext, _yield$this$getProjec, attributes, pagination;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.allProjectAttributesCancelToken;
                },
                setter: function setter(token) {
                  return _this3.allProjectAttributesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.allProjectAttributesCancelToken = undefined;
                }
              }), config);
              projectAttributes = [];
              payload = {
                limit: 1000,
                offset: 0
              };
              hasNext = true;
            case 4:
              if (!hasNext) {
                _context2.next = 15;
                break;
              }
              _context2.next = 7;
              return this.getProjectAttributes(projectId, payload, conf);
            case 7:
              _yield$this$getProjec = _context2.sent;
              attributes = _yield$this$getProjec.attributes;
              pagination = _yield$this$getProjec.pagination;
              Array.prototype.push.apply(projectAttributes, attributes);
              hasNext = !!pagination.next;
              if (hasNext) payload.offset += payload.limit;
              _context2.next = 4;
              break;
            case 15:
              return _context2.abrupt("return", {
                attributes: projectAttributes
              });
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getAllProjectAttributes(_x4, _x5) {
        return _getAllProjectAttributes.apply(this, arguments);
      }
      return getAllProjectAttributes;
    }()
    /**
     * batch create custom attributes. The batch size should not more than 100.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/49edd81d63eed-batch-create-custom-attribute-definitions
     *
     * @param projectId -  the project id.
     * @param folderUrn -  to check if the user has permission to operate the fold or not
     * @param payload - the list of custom attribute with the shape of
     *                           name, type, description, options
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchCreateAttributes",
    value: (function () {
      var _batchCreateAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, folderUrn, payload, config) {
        var query, response, _response$data2, _response$data2$resul, results, errors;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = folderUrn ? QS.stringify({
                folderUrn: folderUrn
              }, {
                addQueryPrefix: true
              }) : '';
              _context3.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions:batch-create").concat(query), payload, config);
            case 3:
              response = _context3.sent;
              _response$data2 = response.data, _response$data2$resul = _response$data2.results, results = _response$data2$resul === void 0 ? [] : _response$data2$resul, errors = _response$data2.errors;
              return _context3.abrupt("return", {
                results: results.map(CustomAttribute.parseV3),
                errors: errors
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function batchCreateAttributes(_x6, _x7, _x8, _x9) {
        return _batchCreateAttributes.apply(this, arguments);
      }
      return batchCreateAttributes;
    }()
    /**
     * batch update custom attributes. The batch size should not more than 100.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/69ea96607ee37-batch-update-custom-attribute-definitions
     *
     * @param projectId -  the project id.
     * @param folderUrn -  to check if the user has permission to operate the fold or not
     * @param payload - the list of custom attribute with the shape of
     *                           id, name, description, options
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchUpdateAttributes",
    value: (function () {
      var _batchUpdateAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, folderUrn, payload, config) {
        var query, response, _response$data3, _response$data3$resul, results, errors;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = folderUrn ? QS.stringify({
                folderUrn: folderUrn
              }, {
                addQueryPrefix: true
              }) : '';
              _context4.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions:batch-update").concat(query), payload, config);
            case 3:
              response = _context4.sent;
              _response$data3 = response.data, _response$data3$resul = _response$data3.results, results = _response$data3$resul === void 0 ? [] : _response$data3$resul, errors = _response$data3.errors;
              return _context4.abrupt("return", {
                results: results.map(CustomAttribute.parseV3),
                errors: errors
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function batchUpdateAttributes(_x10, _x11, _x12, _x13) {
        return _batchUpdateAttributes.apply(this, arguments);
      }
      return batchUpdateAttributes;
    }()
    /**
     * batch delete custom attributes. The batch size should not more than 100.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/2e97aadc019ed-batch-delete-custom-attribute-definitions
     *
     * @param projectId -  the project id.
     * @param folderUrn -  to check if the user has permission to operate the fold or not
     * @param payload - the list of custom attribute id
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchDeleteAttributes",
    value: (function () {
      var _batchDeleteAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, folderUrn, payload, config) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              query = folderUrn ? QS.stringify({
                folderUrn: folderUrn
              }, {
                addQueryPrefix: true
              }) : '';
              _context5.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions:batch-delete").concat(query), payload, config);
            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function batchDeleteAttributes(_x14, _x15, _x16, _x17) {
        return _batchDeleteAttributes.apply(this, arguments);
      }
      return batchDeleteAttributes;
    }()
    /**
     * Get custom attributes attached to the folder, support sort by name/id, support pagination
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1b51732e34284-get-folder-s-visible-custom-attribute-definitions
     *
     * @param projectId -  the project id.
     * @param folderUrn -  target folder urn.
     * @param params - the query parameters with the shape of
     *                          offset, limit, sort
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getFolderAttributes",
    value: (function () {
      var _getFolderAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, folderUrn, params, config) {
        var _this4 = this;
        var conf, query, response, _response$data4, _response$data4$resul, results, pagination;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.folderAttributesCancelToken.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this4.folderAttributesCancelToken.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this4.folderAttributesCancelToken["delete"](folderUrn);
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              _context6.next = 4;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/custom-attribute-definitions").concat(query), conf);
            case 4:
              response = _context6.sent;
              _response$data4 = response.data, _response$data4$resul = _response$data4.results, results = _response$data4$resul === void 0 ? [] : _response$data4$resul, pagination = _response$data4.pagination;
              return _context6.abrupt("return", {
                attributes: results.map(CustomAttribute.parseV3),
                pagination: parsePagination(pagination)
              });
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getFolderAttributes(_x18, _x19, _x20, _x21) {
        return _getFolderAttributes.apply(this, arguments);
      }
      return getFolderAttributes;
    }()
    /**
     * batch set(attach/detach) custom attributes. The batch size should not more than 100.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/a589848df3c3f-batch-attach-detach-custom-attribute-definitions
     *
     * @param projectId -  the project id.
     * @param payload - the list of object with the shape of
     *                           id, folderUrn, action
     * @param params - the query parameters with the shape of
     *                          forceSet: true / false // Use true only if payload contains 1 item. Default to false
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchSetFolderAttributes",
    value: (function () {
      var _batchSetFolderAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, payload, params, config) {
        var query, response, _response$data5, _response$data5$resul, _response$data5$resul2, attachList, _response$data5$resul3, detachList, errors;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              _context7.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions:batch-set").concat(query), payload, config);
            case 3:
              response = _context7.sent;
              _response$data5 = response.data, _response$data5$resul = _response$data5.results, _response$data5$resul2 = _response$data5$resul.attachList, attachList = _response$data5$resul2 === void 0 ? [] : _response$data5$resul2, _response$data5$resul3 = _response$data5$resul.detachList, detachList = _response$data5$resul3 === void 0 ? [] : _response$data5$resul3, errors = _response$data5.errors;
              return _context7.abrupt("return", {
                results: {
                  attachList: attachList.map(function (a) {
                    return _extends({}, CustomAttribute.parseV3(a), {
                      folderUrn: a.folderUrn
                    });
                  }),
                  detachList: detachList
                },
                errors: errors
              });
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function batchSetFolderAttributes(_x22, _x23, _x24, _x25) {
        return _batchSetFolderAttributes.apply(this, arguments);
      }
      return batchSetFolderAttributes;
    }()
    /**
     * Get folders where the custom attribute attached to, support pagination
     * https://platform.stoplight.autodesk.com/docs/docs-cp/20364c6c6cf7d-return-a-custom-attribute-definition-s-folders
     *
     * @param projectId -  the project id.
     * @param customAttributeId - target custom attribute.
     * @param params - the query parameters with the shape of
     *                          offset, limit
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getAttributeFolders",
    value: (function () {
      var _getAttributeFolders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(projectId, customAttributeId, params, config) {
        var _this5 = this;
        var conf, query, response, _response$data6, _response$data6$resul, results, pagination, folders;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this5.attributeFoldersCancelToken;
                },
                setter: function setter(token) {
                  return _this5.attributeFoldersCancelToken = token;
                },
                clearer: function clearer() {
                  return _this5.attributeFoldersCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              _context8.next = 4;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/custom-attribute-definitions/").concat(customAttributeId, "/folders").concat(query), conf);
            case 4:
              response = _context8.sent;
              _response$data6 = response.data, _response$data6$resul = _response$data6.results, results = _response$data6$resul === void 0 ? [] : _response$data6$resul, pagination = _response$data6.pagination;
              folders = results.map(function (_ref) {
                var attachedBy = _ref.attachedBy,
                  attachedStatus = _ref.attachedStatus,
                  folder = _objectWithoutProperties(_ref, _excluded);
                return _extends({}, FolderItem.parseV3(folder), {
                  attachedBy: attachedBy,
                  attachedStatus: attachedStatus
                });
              });
              return _context8.abrupt("return", {
                folders: folders,
                pagination: parsePagination(pagination)
              });
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAttributeFolders(_x26, _x27, _x28, _x29) {
        return _getAttributeFolders.apply(this, arguments);
      }
      return getAttributeFolders;
    }()
    /**
     * Update custom attribute value for a specific document
     *
     * @param projectId -  the project id.
     * @param folderUrn -  target folder urn.
     * @param documentUrn - target document urn.
     * @param payload - custom attribute value info with the shape of
     *                           custom_attributes: [id, value]
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "updateDocumentAttributes",
    value: (function () {
      var _updateDocumentAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(projectId, folderUrn, documentUrn, payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this.Config.product === DOCS_PRODUCTS.ACC) {
                deprecatedWarning('CustomAttributes.updateDocumentAttributes', 'CustomAttributes.batchUpdateAttributeValues');
              }
              _context9.next = 3;
              return this.HttpService.dmV1.patch("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/documents/").concat(documentUrn, "/custom_attributes"), payload, config);
            case 3:
              response = _context9.sent;
              return _context9.abrupt("return", response.data);
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function updateDocumentAttributes(_x30, _x31, _x32, _x33, _x34) {
        return _updateDocumentAttributes.apply(this, arguments);
      }
      return updateDocumentAttributes;
    }()
    /**
     * Add custom attribute
     *
     * @param projectId -  the project id.
     * @param folderUrn -  target folder urn.
     * @param payload - custom attribute value info with the shape of `attribute_type`, `name`, `value`
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "addAttribute",
    value: (function () {
      var _addAttribute = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(projectId, folderUrn, payload, config) {
        var _response$data7;
        var response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.HttpService.dmV1.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/custom_attributes"), payload, config);
            case 2:
              response = _context10.sent;
              return _context10.abrupt("return", CustomAttribute.parseV1((_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.custom_attribute));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function addAttribute(_x35, _x36, _x37, _x38) {
        return _addAttribute.apply(this, arguments);
      }
      return addAttribute;
    }()
    /**
     * Update custom attributes under a specific folder
     * https://platform.stoplight.autodesk.com/docs/docs-v1/b0a55f71e9c4e-update-folder-custom-attribute
     *
     * @param projectId -  the project id.
     * @param folderUrn -  target folder urn.
     * @param payload - custom attribute value info with the shape of
     *                           custom_attributes: [id, name, value]
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "updateAttributes",
    value: (function () {
      var _updateAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(projectId, folderUrn, payload, config) {
        var _response$data8;
        var response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.HttpService.dmV1.put("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/custom_attributes/update"), payload, config);
            case 2:
              response = _context11.sent;
              return _context11.abrupt("return", (((_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.custom_attributes) || []).map(CustomAttribute.parseV1));
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function updateAttributes(_x39, _x40, _x41, _x42) {
        return _updateAttributes.apply(this, arguments);
      }
      return updateAttributes;
    }()
    /**
     * Update custom attribute visibility for a specific folder
     * https://platform.stoplight.autodesk.com/docs/docs-v1/0a0e25805ad25-folder-custom-attribute-visibility
     *
     * @param projectId -  the project id.
     * @param folderUrn -  target folder urn.
     * @param payload - custom attribute value info with the shape of
     *                           custom_attributes: [id, visible]
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "updateAttributesVisibility",
    value: (function () {
      var _updateAttributesVisibility = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(projectId, folderUrn, payload, config) {
        var _response$data9;
        var response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.HttpService.dmV1.patch("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/custom_attributes/visibility"), payload, config);
            case 2:
              response = _context12.sent;
              return _context12.abrupt("return", (((_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.folder_custom_attribute_entities) || []).map(CustomAttribute.parseV1));
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function updateAttributesVisibility(_x43, _x44, _x45, _x46) {
        return _updateAttributesVisibility.apply(this, arguments);
      }
      return updateAttributesVisibility;
    }()
    /**
     * Batch get custom attribute ids attached to a batch of folders
     * https://platform.stoplight.autodesk.com/docs/docs-cp/fe8f691a25ffb-batch-get-folder-related-custom-attributes
     *
     * @param projectId -  the project id.
     * @param folderUrn -  target folder urn.
     * @param payload - with the shape of
     *                          folderUrnList: ['urn-1', 'urn-2']
     * @param config - Configurable object to overwrite request parameters.
     * @returns attribute ids attached to each folder urn.
     */
    )
  }, {
    key: "batchGetFolderAttributes",
    value: (function () {
      var _batchGetFolderAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(projectId, folderUrn, payload, config) {
        var _this6 = this;
        var conf, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this6.batchGetFolderAttributeCancelToken;
                },
                setter: function setter(token) {
                  return _this6.batchGetFolderAttributeCancelToken = token;
                },
                clearer: function clearer() {
                  return _this6.batchGetFolderAttributeCancelToken = undefined;
                }
              }), config);
              _context13.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/folders/").concat(folderUrn, "/custom-attribute-definitions:batch-get"), payload, conf);
            case 3:
              response = _context13.sent;
              return _context13.abrupt("return", response.data);
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function batchGetFolderAttributes(_x47, _x48, _x49, _x50) {
        return _batchGetFolderAttributes.apply(this, arguments);
      }
      return batchGetFolderAttributes;
    }()
    /**
     * Batch get custom attribute constraints
     * https://platform.stoplight.autodesk.com/docs/docs-cp/d018a5eb89fbe-batch-get-custom-attribute-constraints
     *
     * @param projectId -  the project id.
     * @param folderUrn -  to check if the user has permission to operate the folder or not
     * @param payload - with the shape of attributeIds: []
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchGetAttributeConstraints",
    value: (function () {
      var _batchGetAttributeConstraints = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(projectId, folderUrn, payload, config) {
        var _this7 = this;
        var conf, query, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this7.batchGetAttributeConstraintsToken;
                },
                setter: function setter(token) {
                  return _this7.batchGetAttributeConstraintsToken = token;
                },
                clearer: function clearer() {
                  return _this7.batchGetAttributeConstraintsToken = undefined;
                }
              }), config);
              query = QS.stringify({
                folderUrn: folderUrn
              }, {
                addQueryPrefix: true
              });
              _context14.next = 4;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions/constraints:batch-get").concat(query), payload, conf);
            case 4:
              response = _context14.sent;
              return _context14.abrupt("return", response.data);
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function batchGetAttributeConstraints(_x51, _x52, _x53, _x54) {
        return _batchGetAttributeConstraints.apply(this, arguments);
      }
      return batchGetAttributeConstraints;
    }()
    /**
     * Batch set custom attribute constraints
     * https://platform.stoplight.autodesk.com/docs/docs-cp/aa511632cdde8-batch-update-insert-custom-attribute-definition-constraint
     *
     * @param projectId -  the project id.
     * @param folderUrn -  to check if the user has permission to operate the folder or not
     * @param payload - the list with the shape of `attributeId` and `constraints`
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchSetAttributeConstraints",
    value: (function () {
      var _batchSetAttributeConstraints = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(projectId, folderUrn, payload, config) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              query = QS.stringify({
                folderUrn: folderUrn
              }, {
                addQueryPrefix: true
              });
              _context15.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions/constraints:batch-upsert").concat(query), payload, config);
            case 3:
              response = _context15.sent;
              return _context15.abrupt("return", response.data);
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function batchSetAttributeConstraints(_x55, _x56, _x57, _x58) {
        return _batchSetAttributeConstraints.apply(this, arguments);
      }
      return batchSetAttributeConstraints;
    }()
    /**
     * Batch get custom attributes by attribute ids
     * https://platform.stoplight.autodesk.com/docs/docs-cp/53989ccf300a3-batch-get-custom-attribute-definitions-by-ids
     *
     * @param projectId -  the project id.
     * @param folderUrn -  the folder urn used to check permission.
     * @param payload - with the shape of `attributeIds`
     * @param config - Configurable object to overwrite request parameters.
     * @returns detail info for each attribute.
     */
    )
  }, {
    key: "batchGetAttributes",
    value: (function () {
      var _batchGetAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(projectId, folderUrn, payload, config) {
        var query, response, _response$data10, _response$data10$resu, results, _response$data10$erro, errors;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              query = QS.stringify({
                folderUrn: folderUrn
              }, {
                addQueryPrefix: true
              });
              _context16.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/custom-attribute-definitions:batch-get").concat(query), payload, config);
            case 3:
              response = _context16.sent;
              _response$data10 = response.data, _response$data10$resu = _response$data10.results, results = _response$data10$resu === void 0 ? [] : _response$data10$resu, _response$data10$erro = _response$data10.errors, errors = _response$data10$erro === void 0 ? [] : _response$data10$erro;
              return _context16.abrupt("return", {
                errors: errors,
                results: results.map(CustomAttribute.parseV3)
              });
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function batchGetAttributes(_x59, _x60, _x61, _x62) {
        return _batchGetAttributes.apply(this, arguments);
      }
      return batchGetAttributes;
    }()
    /**
     * Batch update attribute values for files
     * https://platform.stoplight.autodesk.com/docs/docs-cp/88b7c7eeb198a-batch-update-documents-custom-attributes
     *
     * @param projectId -  the project id
     * @param payload - the update attributes for files
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "batchUpdateAttributeValues",
    value: (function () {
      var _batchUpdateAttributeValues = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(projectId, payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/documents/custom-attributes:batch-update"), payload, config);
            case 2:
              response = _context17.sent;
              return _context17.abrupt("return", response.data || {});
            case 4:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function batchUpdateAttributeValues(_x63, _x64, _x65) {
        return _batchUpdateAttributeValues.apply(this, arguments);
      }
      return batchUpdateAttributeValues;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'CustomAttributes';
    }
  }]);
}(Base);
export default CustomAttributes;